import { render, staticRenderFns } from "./CustomeSVG.vue?vue&type=template&id=80a15850&"
import script from "./CustomeSVG.vue?vue&type=script&lang=js&"
export * from "./CustomeSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports